var app = angular.module("leonardo");

var TaskAddNoteDialog = function($scope, $q, $state, ngDialog, NoteService, AttachmentService, FormErrorsService, UserService, AccountUserRoleService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.action = $scope.ngDialogData.action;
  $scope.note = $scope.ngDialogData.note;
  $scope.userService = UserService;
  $scope.accountUserRoleService = AccountUserRoleService;
  
  if ($scope.note) {
    $scope.data = angular.copy($scope.note);
    $scope.attachments_old = $scope.data.attachments;
  }
  else{
    $scope.data = {};
    $scope.attachments_old = [];
  }
  $scope.attachments = [];

  $scope.task.property = $scope.task.property?.id || $scope.task.property;
  $scope.task.portfolio = $scope.task.portfolio?.id || $scope.task.portfolio;

  $scope.isMyApprovals = function () {
    return ['approvals', 'property.tasks.approval'].includes($state.current.name);
  }

  $scope.removeAttachment = function(index, old) {
    if (old) {
      $scope.attachments_old.splice(index, 1);
    }
    else {
      $scope.attachments.splice(index, 1);
    }
  };

  $scope.showAttachDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: {task: {}, mode: 'upload_note'}
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments.push(attachment);
      });
    }, function () {
      return;
    });
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    data['attachments'] = [];
    var promises = [];
    angular.forEach($scope.attachments_old, function(attachment) {
      data['attachments'].push(attachment.id);
    });
    angular.forEach($scope.attachments, function(attachment) {
      if (attachment.document_folder || attachment.document_file) {
        promises.push(AttachmentService.linkTo(attachment, $scope.task.id).then(function(response){
          data['attachments'].push(response.data.id);
        }));
      }
      else if (attachment.link) {
        promises.push(AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account, $scope.task.id).then(function(response){
          data['attachments'].push(response.data.id);
        }));
      }
      else {
        promises.push(AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account, $scope.task.id).then(function(response){
          data['attachments'].push(response.data.id);
        }));
      }
    });
    data['actionitem_set'] = [];
    data['actionitem_set'].push($scope.task.id);
    $q.all(promises).then(function() {
      if ($scope.action === 'edit') {
        $scope.note.patch({actionitem_set: data['actionitem_set'], attachments: data['attachments'], text: data['text'], important: data['important']}).then(function(note){
          $scope.confirm(note);
        });
      }
      else {
        NoteService.post(data).then(function (note) {
          $scope.confirm(note);
        });
      }
    });
  };
};

app.controller('TaskAddNoteDialog', ['$scope', '$q', '$state', 'ngDialog', 'NoteService', 'AttachmentService',
  'FormErrorsService', 'UserService', 'AccountUserRoleService', TaskAddNoteDialog]);
